"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  shortcuts: [{
    text: '昨天',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近七天',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '本月',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近30天',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一年',
    onClick: function onClick(picker) {
      var end = new Date();
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      picker.$emit('pick', [start, end]);
    }
  }],
  disabledDate: function disabledDate(time) {
    var curDate = new Date().getTime();
    var three = 365 * 24 * 3600 * 1000;
    var threeMonths = curDate - three;
    return time.getTime() > Date.now() || time.getTime() < threeMonths;
    ;
  }
};